import { registerIconLibrary } from "@awesome.me/webawesome";
import * as fontawesome from "@fortawesome/fontawesome-svg-core";

// Register the Font Awesome icons with Web Awesome so they can be used via
// the wa-icon component.
//
// We use the library name "default" to replace Web Awesome's default icon
// library and make the markup needed to use our icons shorter.
registerIconLibrary("default", {
  resolver: (name: string): string => {
    const dashIndex = name.indexOf("-");
    const icon = fontawesome.icon({
      prefix: name.slice(0, dashIndex) as fontawesome.IconPrefix,
      iconName: name.slice(dashIndex + 1) as fontawesome.IconName,
    });
    const svg = icon.html.join("");
    return `data:image/svg+xml,${encodeURIComponent(svg)}`;
  },
  mutator: (svg: SVGElement): void => {
    svg.setAttribute("fill", "currentColor");
  },
});

// Register country flag icons.
//
// Serve the flags as separate static files. If Vite inlines them as data
// URIs, the main bundle becomes much larger.
const flagUrls = import.meta.glob<string>(
  "../../node_modules/flag-icons/flags/4x3/*.svg",
  { query: "?no-inline", import: "default", eager: true },
);
registerIconLibrary("flags", {
  resolver: (name: string): string =>
    flagUrls[`../../node_modules/flag-icons/flags/4x3/${name}.svg`] ?? "",
});
